import React from "react";
import { Box } from "@components/Box/Box";
import { VideoField } from "@helpers/interfaces/media";
import styles from "./styles.module.scss";
import LazyLoad from "react-lazyload";

export interface MediaProps {
  video?: VideoField;
}

const UmbracoVideo: React.FC<MediaProps> = ({ video, ...props }) => {
  return (
    <LazyLoad>
      <Box
        className={styles.video}
        {...(video && {
          dangerouslySetInnerHTML: {
            __html: video.html
              .replace(/(width\s*=\s*["'](.*?)["'])/g, "")
              .replace(/(height\s*=\s*["'](.*?)["'])/g, "")
          }
        })}
        {...props}
      />
    </LazyLoad>
  );
};

UmbracoVideo.defaultProps = {};

export { UmbracoVideo };
